import { useContext } from 'react';
import { RegulationChartsDataContext } from '../contexts/RegulationChartsDataContext';

export const useRegulationChartsDataContext = () => {
    return useContext(RegulationChartsDataContext);
};
